module.exports = __webpack_public_path__ + "img/qrcode_bg_new.90cf1e7f.png";